import { apiGet, apiPost, apiPut, mockSuccess } from "@redriver/cinnamon";
import {
  getCompletedStepIndex,
  getIsConfirmed,
  getIsSubmitted,
  getRepFormData,
  getSteps,
} from "./selectors";
import { RepInfoSteps } from "constants/enums";

const NAMESPACE = "REP_DETAILS";

export const ActionTypes = {
  GetRepInfo: `${NAMESPACE}/GET_REP_INFO`,
  MoveStep: `${NAMESPACE}/MOVE_STEP`,
  UpdateForm: `${NAMESPACE}/UPDATE_FORM`,
  SaveStep: `${NAMESPACE}/SAVE_STEP`,
  Submit: `${NAMESPACE}/SUBMIT`,
  GetCountries: `${NAMESPACE}/GET_COUNTRIES`,
  GetGenderOptions: `${NAMESPACE}/GET_GENDER_OPTIONS`,
  GetTitles: `${NAMESPACE}/GET_TITLES`,
  GetUniformSizes: `${NAMESPACE}/GET_UNIFORM_SIZES`,
  SetValidation: `${NAMESPACE}/SET_VALIDATION`,
};

export const getRepInfo = () => {
  return apiGet(ActionTypes.GetRepInfo, "resort-reps/answer-set");
};

export const moveStep = ({ targetStepKey }) => ({
  type: ActionTypes.MoveStep,
  targetStepKey,
});

export const updateForm = ({ applyChanges }) => ({
  type: ActionTypes.UpdateForm,
  applyChanges,
});

export const saveStep =
  ({ stepKey, completedStepIndex, isDirty }) =>
  (dispatch, getState) => {
    const state = getState();
    const formState = getRepFormData(state);
    const isConfirmed = getIsConfirmed(state);
    const request = {
      data: {
        [stepKey]: formState[stepKey],
      },
      completedStepIndex,
      isConfirmed:
        isConfirmed ||
        (formState[RepInfoSteps.Submit] &&
          formState[RepInfoSteps.Submit].agree),
    };
    return dispatch(
      apiPut(ActionTypes.SaveStep, `resort-reps/answer-set`, request, {
        actionCustomData: {
          isDirty,
        },
      })
    );
  };

export const getCountries = () =>
  apiGet(ActionTypes.GetCountries, `lookup/countries`);

export const getGenderOptions = () =>
  apiGet(ActionTypes.GetGenderOptions, `lookup/gender`);

export const getTitles = () => apiGet(ActionTypes.GetTitles, `lookup/titles`);
export const getUniformSizes = () =>
  apiGet(ActionTypes.GetUniformSizes, `lookup/uniform-sizes`);

export const setValidation = (isValid) => ({
  type: ActionTypes.SetValidation,
  isValid,
});
